import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { Helpers } from '@grandvisionhq/products';
import { getLocalizedValue, getAttrValue } from '@grandvisionhq/utils';

function createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale) {
    const activeVariant = Helpers.getActiveVariant(product, sku);
    const productName = product && getLocalizedValue(product.name, locale);
    if (productType && (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType))) {
        return productName && sku && categoryBreadcrumb ? {
            name: productName
        } : null;
    }
    if (productType && CommerceToolsApi.isSolutions(productType)) {
        const packageOption = activeVariant && getAttrValue(activeVariant, 'packageOption');
        return productName && packageOption && sku && categoryBreadcrumb ? {
            name: `${productName} ${packageOption}`
        } : null;
    }
    return activeVariant.name && sku && categoryBreadcrumb ? {
        name: activeVariant.name
    } : null;
}

export { createProductBreadcrumb };
//# sourceMappingURL=create-product-breadcrumb.js.map
